/*Package importing*/
import React, { Component } from 'react';
import $ from 'jquery';

/*Components*/
import Inputs from '../../components/formComponents/inputs.js';
import DateRange from '../../components/dateRangePicker/dateRange.js';
import SelectBox from '../../components/formComponents/selectBox';

import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

/*Assets*/
import success from '../../assets/images/success.png';


class PurchaseModal extends Component {
  constructor(props){
    super(props);
    this.state = {
      name: "",
      amount: "",
      gst: "",
      planType: 1,
      transaction_id: "",
      success: false
    }
  }
   selectChange = async (category) => {
    await this.setState({category: category});
  }

  paymentSuccess(response){
    console.log(response.razorpay_payment_id);
    console.log(response.razorpay_order_id);
    console.log(response.razorpay_signature)

    this.setState({transaction_id: response.razorpay_payment_id});

    var url = devconfig.vendor+ 'plan/confirm-payment';
    var data = JSON.stringify({ 
      payment_status: true, 
      transaction_id: response.razorpay_payment_id,
      invoice_id: this.state.invoiceData.invoice_id, 
      invoice_no: this.state.invoiceData.invoice_no 
    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        // $("#"+this.props.id).modal('hide');
        // this.props.paymentSuccess();
        this.setState({success: true});
        // window.location.reload(true);
      }
    }.bind(this))
  }

  openRazorpay(){
    var url = devconfig.vendor+ 'plan/purchase';
    var data = JSON.stringify({ plan_id: this.props.data.id, payment_type: this.state.paymentType });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        this.setState({invoiceData: response.data});
        var options = {
            "key": "rzp_live_sQGRf14RB4V85K", // Enter the Key ID generated from the Dashboard
            "amount": response.data.amount*100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "TrueKhoj",
            "description": "Plan purchase",
            "image": "https://truekhoj.com/static/media/logo.334a1bb1.svg",
            // "order_id": "order_9A33XWu170gUtm", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": (response)=>{
                this.paymentSuccess(response);
            },
            "prefill": {
                "name": this.state.vendorData.name,
                "email": this.state.vendorData.email,
                "contact": this.state.vendorData.mobile
            },
            "notes": {
                "plan_id": this.props.data.id,
                "plan_name": this.props.data.name
            },
            "theme": {
                "color": "#ff4a31"
            }
        };
    var rzp1 = new window.Razorpay(options);
    rzp1.on('payment.failed', function (response){
        console.log(response.error.code);
        console.log(response.error.description);
        console.log(response.error.source);
        console.log(response.error.step);
        console.log(response.error.reason);
        console.log(response.error.metadata.order_id);
        console.log(response.error.metadata.payment_id);
    });
        rzp1.open();
      }
      console.log("Response: ", response.data);
      console.log("Options: ", options);
    }.bind(this))
    
  }


  componentDidMount(){
    var localStorageData = localStorage.getItem("vendor_data");
    if(localStorageData){
      var parsedData = JSON.parse(localStorageData);
      this.setState({vendorData: parsedData})
    }

    if(this.props.data.type_id == 2){
      this.setState({paymentType: 1, planType: 2})
    }
  }

  success(){
    this.props.paymentSuccess();
    window.location.reload(true);
  }

  render() {

    const filterBy = [
      { value: 1, label: 'Active' },
      { value: 2, label: 'Ongoing' },
      { value: 3, label: 'Completed' },
    ]

    console.log("this.props.datathis.props.datathis.props.datathis.props.data");
    console.log(this.props.data);

    return (
      <div className="modal fade e-ad-detail-wrap  e-ofer-modal" id={this.props.id} tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="purchaseModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered"  role="document">
          <div className="modal-content e-ofer e-purchase-modal">
            <div className="modal-header">
              {
                !this.state.success ?
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                :
                  null
              }
              
            </div>
            {/*<div className="row">
                <div className="col-lg-6" onClick={()=>{this.setState({paymentType: 1})} }>
                  <label>One-time Payment</label>
                  <input type="radio" value="1" checked={this.state.paymentType===1} name="payment-type" onClick={()=>{this.setState({paymentType: 1})} }/> 
                </div>
                <div className="col-lg-6" onClick={()=>{this.setState({paymentType: 2})}}>
                  <label> EMI</label>
                  <input type="radio" value="1" checked={this.state.paymentType===2} name="payment-type" onClick={()=>{this.setState({paymentType: 2})} }/>
                </div>  
              </div>
            <div className="row">
              <div className="col-lg-8">
                <h6 className="e-purchase-header">Plan</h6>
              </div>
              <div className="col-lg-4">
                <h6 className="e-purchase-header">Amount</h6>
              </div>
            </div>
            <div className="e-border-accordion e-purchase-border-top">
              <div className="row mt-4 mb-3">
                <div className="col-lg-8">
                  <h6>{this.props.data.name}</h6>
                </div>
                <div className="col-lg-4">
                  <h6> {this.props.data.offer_price}</h6>
                </div>
              </div>
            </div>
            <div className="e-border-accordion pt-2">
              {
                this.state.paymentType===1?
                  <div className="row my-3">
                    <div className="col-lg-3 offset-5 pr-0">
                      <h6 className="e-purchase-header">Subtotal:</h6>
                      <h6 className="e-purchase-header e-border-bottom py-2 pl-4 ml-1">IGST:</h6>
                      <h6 className="e-purchase-header pt-2 pl-4 ml-1">Total:</h6>
                    </div>
                    <div className="col-lg-3 pl-0">
                      <h6 className="pl-3">{this.props.data.offer_price}</h6>
                      <h6 className="pt-2 e-border-bottom py-2 pl-3">{this.props.data.offer_price * .18}</h6>
                      <h6 className="e-purchase-header pt-2 pl-3">{this.props.data.offer_price + this.props.data.offer_price * .18} /-</h6>
                    </div>
                  </div>
                :
                  <div className="row my-3">
                    <div className="col-lg-3 offset-5 pr-0">
                      <h6 className="e-purchase-header">First EMI:</h6>
                      <h6 className="e-purchase-header e-border-bottom py-2 pl-4 ml-1">IGST:</h6>
                      <h6 className="e-purchase-header pt-2 pl-4 ml-1">Total:</h6>
                    </div>
                    <div className="col-lg-3 pl-0">
                      <h6 className="pl-3">{this.props.data.emi_amount}</h6>
                      <h6 className="pt-2 e-border-bottom py-2 pl-3">{this.props.data.offer_price * .18}</h6>
                      <h6 className="e-purchase-header pt-2 pl-3">{this.props.data.emi_amount + this.props.data.offer_price * .18} /-</h6>
                    </div>
                  </div>
              }
            </div>
            <div className="row">
              <button className="e-s-btn e-new-ofer float-right" type="submit" value="Submit" onClick={this.openRazorpay.bind(this)}>Pay Now</button>
            </div>*/}

            {
              !this.state.success ?
                <div className="e-purchase-plan-modal-wrap">
                  <h6>Plan Selected: <span>{this.props.data.name}</span></h6>
                  
                  {
                    this.state.planType == 2 ?
                      <p>₹{this.props.data.offer_price} One time for {this.props.data.no_of_pay} months.</p>
                    :
                      <React.Fragment>
                        <p>₹{this.props.data.offer_price} One time or EMI of ₹ {this.props.data.emi_amount} per month for {this.props.data.no_of_pay} months.</p>
                        <h6>How do you want to pay for '{this.props.data.name}'?</h6>
                        <div className="row">
                          <div className="col-lg-6" onClick={()=>{this.setState({paymentType: 1})} }>
                            <div className="position-relative">
                              <label className="e-radio-label">One-time Payment</label>
                              <input type="radio" value="1" checked={this.state.paymentType == 1 ? true : false} name="payment-type" onClick={()=>{this.setState({paymentType: 1})} }/> 
                            </div>
                          </div>
                          <div className="col-lg-6" onClick={()=>{this.setState({paymentType: 2})}}>
                            <div className="position-relative">
                              <label className="e-radio-label"> EMI</label>
                              <input type="radio" value="1" checked={this.state.paymentType == 2 ? true : false} name="payment-type" onClick={()=>{this.setState({paymentType: 2})} }/>
                            </div>
                          </div>  
                        </div>
                      </React.Fragment>
                  }

                  
                  {
                    this.state.paymentType ?
                      <div className="row mt-2">
                        <div className="col-lg-12">
                          {
                            this.state.paymentType === 1 ?
                              <h6>Total Payable Amount: ₹ {this.props.data.offer_price + this.props.data.offer_price * .18}, <b>Inc.{"GST 18% (₹ "+this.props.data.offer_price * .18+")"}</b></h6>
                            :
                              
                              <h6>Total Payable Amount: ₹ {this.props.data.emi_amount + this.props.data.offer_price * .18}, <b>Inc.{"GST 18% (₹ "+this.props.data.offer_price * .18+")"}</b></h6>
                          }
                        </div>
                      </div>
                    :
                      null
                  }

                  <div className="row mb-4 mt-3">
                    <div className="col-lg-12">
                      {
                        this.state.paymentType ?
                          <button className="e-p-btn" onClick={this.openRazorpay.bind(this)}>Proceed</button>
                        :
                          <button className="e-p-btn e-inactive" >Proceed</button>
                      }
                    </div>
                  </div>
                </div>
              :
                <div className="e-purchase-plan-success text-center">
                  <img src={success} />
                  <h5 className="mt-4 mb-4">Successfully Purchased Plan '{this.props.data.name}'</h5>
                  {
                    this.state.transaction_id.length ?
                      <p>Transaction ID: {this.state.transaction_id}</p>
                    :
                      null
                  }
                  <button className="e-p-btn" type="submit" value="Submit" onClick={this.success.bind(this)}>OK</button>
                </div>
            }

            


            

          </div>
        </div>
      </div>
    );
  }
}

export default PurchaseModal;
